import React from "react";
import Localized from "../components/localized";

const withLocalization = Wrapped => {
    return props => {
        return (
            <Localized>
                <Wrapped {...props} />
            </Localized>
        );
    };
};

export default withLocalization;
